const ServerUrl = process.env.API_HOST;
function chnup(event) {
  // return
  var xmlhttp = new XMLHttpRequest();
  xmlhttp.open("POST", ServerUrl + "/open/third/kf/chat_track", true);
  var req_obj = {
    event: event,
  };
  req_obj = JSON.stringify(req_obj);
  xmlhttp.send(req_obj);
}
export { chnup };



// WEBPACK FOOTER //
// ./src/utils/tools.js